import { Logo } from "./LogoVariants";

const Header = (props) => {
  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <Logo variant="shield" size="md" />
          {!props.comingSoon && (
            <nav className="hidden md:flex items-center gap-8">
              <a
                href="#features"
                className="text-gray-600 hover:text-blue-600 transition-colors"
              >
                Features
              </a>
              <a
                href="#how-it-works"
                className="text-gray-600 hover:text-blue-600 transition-colors"
              >
                How It Works
              </a>
              <a
                href="#founder"
                className="text-gray-600 hover:text-blue-600 transition-colors"
              >
                Our Team
              </a>
              <a
                href="#contact"
                className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:shadow-lg transition-shadow"
              >
                Get Started
              </a>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
